export class NavConstants {
    static ADD_ORGANISATION_LINK_TEXT = "Add organisation";
    static LOGOUT_LINK_TEXT = "Logout";
    //static readonly APP_TITLE = "Default Project Title";
    static HOME_LINK_TEXT = "Home";
    static APPLICATIONS_HEADING_TEXT = "Applications";
    static PROPERTIES_HEADING_TEXT = "Properties";
    static LOCATION_HEADING_TEXT = "Cemeteries/Graves";
    static SELECT_MUNICIPALITY_LABEL = "Select municipality";
    static SELECT_APPLICATION_LABEL = "Select application";
    static VIEW_DOCUMENTATION_TEXT = "View documentation";
    static CREATE_APPLICATION_TEXT = "Create application";
    static SEARCH_MY_APPLICATION_TEXT = "Search my applications";
    static DEFAULT_APPLICANT_AGENT_TEXT = "Default Applicant Agent";
    static INCOMPLETE_APPLICATIONS_TITLE = "Incomplete applications";
    static INCOMPLETE_APPLICATIONS_MESSAGE = "The selected module contains incomplete applications. \n\nClick 'OK' to create a new application or click 'Cancel' to open the list of saved / incomplete applications and select the application that you would like to complete.";
    static PLEASE_SELECT_AN_OPTION = "Please select an option";
    static MODAL_OPTIONS = {
        size: "lg",
        centered: true,
        backdrop: "static"
    };
}
